// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__uo2BU","list":"BalanceDue_list__oeXFT","listRow":"BalanceDue_listRow__1OmAj","total":"BalanceDue_total__LrM_g"};